function buildAvSuggestContext(limitedFairEvents) {
  if (!Array.isArray(limitedFairEvents) || !limitedFairEvents.length) {
    return '';
  }

  var avSuggestContext = '{!parent which=type:MkdbExhibitorIndexBundle|||Documents|||Exhibitor v="(';
  for (var i = 0; i < limitedFairEvents.length; i++) {
    if (i !== 0) {
      avSuggestContext += ' OR ';
    }
    avSuggestContext += 'fair_id:' + limitedFairEvents[i];
  }
  avSuggestContext += ')"}';
  return avSuggestContext;
}

function autocomplete() {
  var settings = JSON.parse(document.querySelector('#tx_plussolr_settings').getAttribute('data-search'));
  var searchBoxes = document.querySelectorAll(".js-plussolr-search-form input[type='search']");
  var quicklinks = JSON.parse(document.querySelector('#tx_plussolr_settings').getAttribute('data-quicklinks'));
  var hash = fragmentToArray(window.location.hash);
  var filterQuery = '&fq[]=siteHash:' + settings.siteHash + ' OR type:fair';
  //temporary  stop showing search-results from mkdb
  // if (settings.exhibitor_directory) {
  //   filterQuery += buildAvSuggestContext(settings.exhibitor_directory.limitedFairEvents);
  // }
  var localFilterQuery = '';
  var currentPageId = document.querySelector('body').classList[0].substring(4);

  if (searchBoxes.length === 0) {
    return;
  }

  var searchPageId;
  var searchPageUrl;
  if (searchBoxes[0].dataset.searchpageid) {
    searchPageId = searchBoxes[0].dataset.searchpageid;
    searchPageUrl = searchBoxes[0].dataset.searchpageurl;
  } else {
    var newHeaderElem = document.querySelector('.new-header');
    searchPageId = newHeaderElem.dataset.searchPageId;
    searchPageUrl = newHeaderElem.dataset.searchPageUrl;
  }

  searchBoxes.forEach(function callback(searchBox) {
    var autocompleteContainer = searchBox.form.querySelector('.js-autocomplete');
    var searchForm = searchBox.form;
    var quicklinkContainer = searchForm.querySelector('.js-quicklinks');

    if (typeof hash["q"] !== 'undefined' && hash.q !== "*") {
      searchBox.value = decodeURIComponent(hash.q);
    }

    searchBox.onkeyup = function (event) {
      if (searchBox.value.length < 3) {
        var autocompleteList = autocompleteContainer.querySelector('.dropdown__list');
        if (autocompleteList) {
          autocompleteList.remove();
        }
        return;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        return;
      }

      var xhttp = new XMLHttpRequest();
      xhttp.withCredentials = true;
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          var response;
          try {
            response = JSON.parse(this.responseText);
          } catch (e) {
            return;
          }
          hash = fragmentToArray(window.location.hash);

          // take the searchBox position and render them beneath
          var autocomplete = document.createElement("UL");
          autocomplete.classList.add('dropdown__list');
          for (var j = 0; j < response.autocomplete.length; j++) {
            var li = document.createElement("LI");
            li.classList.add('dropdown__listItem');
            li.dataset.word = response.autocomplete[j].word;
            li.innerHTML = '<span class="dropdown__listItemLink">' + response.autocomplete[j].word + '</span>';

            li.onclick = function (e) {
              for (var i = 0; i < searchBoxes.length; i++) {
                searchBoxes[i].value = this.dataset.word;
              }
              autocomplete.outerHTML = '';
              hash["q"] = this.dataset.word;
              if (currentPageId !== searchPageId) {
                window.location = searchPageUrl + '#' + objectToFragment(hash);
              }
              window.location.hash = objectToFragment(hash);
            };
            autocomplete.appendChild(li);
          }

          autocompleteContainer.innerHTML = '';

          autocompleteContainer.appendChild(autocomplete);

          window.addEventListener('click', function (e) {
            if (searchBox.contains(e.target)) {
              if (searchBox.value === '') {
                if (autocompleteContainer) {
                  autocompleteContainer.classList.add('hide');
                }
                if (quicklinkContainer) {
                  quicklinkContainer.classList.remove('hide');
                }
              } else {
                if (autocompleteContainer) {
                  autocompleteContainer.classList.remove('hide');
                }
                if (quicklinkContainer) {
                  quicklinkContainer.classList.add('hide');
                }
              }
            }
            if (!searchForm.contains(e.target)) {
              autocompleteContainer.classList.add('hide');
            }
          });
        }
      };

      hash = fragmentToArray(window.location.hash);
      if (typeof hash["fq"] !== 'undefined' && hash["fq"].filter(Boolean).length) {
        localFilterQuery = '&fq[]=' + '{!tag%3Dfq}' + hash["fq"].join(' OR ');
      }

      var facetQuery = '';
      if (settings.facets && settings.facets.category) {
        facetQuery = getFilterQueryByFixedFacets(settings.facets.category);
      }
      xhttp.open("GET", settings.uri + "autocomplete?q=" + searchBox.value + filterQuery + localFilterQuery + "&rows=5&origin=" + location.origin + facetQuery, true);
      xhttp.send();
    };

    if (quicklinkContainer) {
      searchBox.onkeydown = function () {
        if (searchBox.value !== '') {
          quicklinkContainer.innerHTML = '';
        }
      };

      searchForm.onclick = function () {
        if (searchBox.value === '' && quicklinks.length) {
          // take the searchBox position and render them beneath
          var frequentlySearchedLabel = quicklinkContainer.dataset.headline;
          var quicklinksContent = '<p class="dropdown__headline">' + frequentlySearchedLabel + '</p><ul class="dropdown__list">';
          for (var i = 0; i < quicklinks.length; i++) {
            quicklinksContent += '<li class="dropdown__listItem">' +
              '<a class="dropdown__listItemLink" href="' + quicklinks[i].target + '">' + quicklinks[i].words + '</a>' +
              '</li>';
          }
          quicklinksContent += '</ul>';
          quicklinkContainer.innerHTML = quicklinksContent;
        }
      };
    }

    searchBox.onkeydown = function (event) {
      var focusClass = 'focused';
      if (document.activeElement === searchBox) {
        var items;
        /* quicklinks or autocomplete items depending on value of searchBox */
        if (searchBox.value === '') {
            items = quicklinkContainer ? quicklinkContainer.querySelectorAll('.dropdown__listItem') : [];
        } else {
          items = autocompleteContainer.querySelectorAll('.dropdown__listItem');
        }

        /* hide containers */
        if (searchBox.value === '') {
          if (quicklinkContainer) {
            quicklinkContainer.classList.remove('hide');
          }
          if (autocompleteContainer) {
            autocompleteContainer.classList.add('hide');
          }
        } else {
          if (quicklinkContainer) {
            quicklinkContainer.classList.add('hide');
          }
          if (autocompleteContainer) {
            autocompleteContainer.classList.remove('hide');
          }
        }

        var activeLinkIndex = -1;
        if (items.length) {
          for (var linkIndex = 0; linkIndex < items.length; linkIndex++) {
            if (items[linkIndex].classList.contains(focusClass)) {
              activeLinkIndex = linkIndex;
            }
          }
          if (event.key === 'ArrowUp') {
            if (activeLinkIndex > 0) {
              items[activeLinkIndex].classList.remove(focusClass);
              items[activeLinkIndex - 1].classList.add(focusClass);
            }
          } else if (event.key === 'ArrowDown') {
            if (activeLinkIndex === -1) {
              items[0].classList.add(focusClass);
            } else if(activeLinkIndex !== items.length - 1) {
              items[activeLinkIndex].classList.remove(focusClass);
              items[activeLinkIndex + 1].classList.add(focusClass);
            }
          } else if (event.key === 'Enter') {
            if (activeLinkIndex > -1) {
              items[activeLinkIndex].querySelector('.dropdown__listItemLink').click();
            }
          }
        }
      }
    };

    window.addEventListener('click', function (e) {
      if (searchBox.contains(e.target)) {
        if (quicklinkContainer) {
          quicklinkContainer.classList.remove('hide');
        }
      }
      if (!searchForm.contains(e.target)) {
        if (quicklinkContainer) {
          quicklinkContainer.classList.add('hide');
        }
      }
    });

    searchForm.onsubmit = function () {
      //var hash = '#q=' + searchBox.value;
      hash["q"] = searchBox.value;
      for (var i = 0; i < searchBoxes.length; i++) {
        searchBoxes[i].value = searchBox.value;
      }
      if (currentPageId !== searchPageId) {
        window.location = searchPageUrl + '#' + objectToFragment(hash);
      }
      window.location.hash = objectToFragment(hash);
      return false;
    };
  });
}

function split(string) {
  for (var i = string.length; i > -1; i--) {
    if (string.charAt(i) === " ") {
      return string.slice(0, i);
    }
  }
}

function fragmentToArray(fragment) {
  var hash = fragment.substring(1).split("&");
  var target = [];
  for (var i = 0; i < hash.length; i++) {
    var kv = hash[i].split("=");
    var value;
    if (kv[0] === 'fq') {
      value = kv[1].split(',');
    } else {
      value = kv[1];
    }
    if (kv[0] !== '') {
      target[kv[0]] = value;
    }
  }
  return target;
}

function objectToFragment(object) {
  var fragment = '';
  var val;
  for (var key in object) {
    if (fragment !== '') {
      fragment += '&';
    }
    if (Array.isArray(object[key])) {
      val = object[key].join(',');
    } else {
      val = object[key];
    }
    if (key !== 'fq') {
      encodeURIComponent(val);
    }
    if (key !== '' && key !== '/') {
      fragment += key + '=' + val;
    }
  }
  return fragment;
}

function getFilterQueryByFixedFacets(categories) {
  var filterQueryByFixedFacets = '';
  if (categories.length) {
    filterQueryByFixedFacets += '&fq[]=';
    categories.forEach(function (category, i) {
      if (i !== 0) {
        filterQueryByFixedFacets += ' OR ';
      }
      filterQueryByFixedFacets += 'category:"' + category.facet + '"';
    });
  }
  return filterQueryByFixedFacets;
}

function getHallNumber(hallId) {
  if (hallId === 'H1') {
    return '1';
  } else if (hallId === 'H2') {
    return '2';
  } else if (hallId === 'H2') {
    return '2';
  } else if (hallId === 'H3') {
    return '3';
  } else if (hallId === 'H4') {
    return '4';
  } else if (hallId === 'H5') {
    return '5';
  } else if (hallId === 'H6') {
    return '6';
  } else if (hallId === 'H7') {
    return '7';
  } else if (hallId === 'H8') {
    return '8';
  } else if (hallId === 'H9') {
    return '9';
  } else if (hallId === 'H10') {
    return '10';
  } else if (hallId === 'GH1') {
    return '1';
  } else {
    return '';
  }
}

function load() {
  var container = document.querySelector(".tx-plussolr-search-show");
  var settings = JSON.parse(document.querySelector('#tx_plussolr_settings').getAttribute('data-search'));
  var allInputLabel = document.querySelector('#tx_plussolr_settings').getAttribute('data-category-all-label');
  if (container) {
    var facetQuery = '';
    var hash = [];

    var filterQuery = '&fq[]=siteHash:' + settings.siteHash + ' OR type:fair';
    //temporary  stop showing search-results from mkdb
    // if (settings.exhibitor_directory) {
    //   filterQuery += buildAvSuggestContext(settings.exhibitor_directory.limitedFairEvents);
    // }
    // get hash object
    if (window.location.hash) {
      hash = fragmentToArray(window.location.hash);
    }

    // This only works for one facet (category)
    if (typeof settings.facets !== 'undefined' && typeof settings.facets.category !== 'undefined') {
      var facets = Object.keys(settings.facets);
      facets.forEach(function callback(facet) {
        facetQuery += '&facet[]=' + facet;
      });
    }

    // required defaults
    hash["q"] = hash["q"] || "*";
    hash["rows"] = hash["rows"] || "10";
    hash["fq"] = hash["fq"] || [];
    // remove empty values
    hash["fq"] = hash["fq"].filter(Boolean);

    var localFilterQuery = '';
    if (hash["fq"].length) {
      localFilterQuery += '&fq[]=' + '{!tag%3Dfq}' + hash["fq"].join(' OR ');
    }

    // search
    var xhttp = new XMLHttpRequest();
    xhttp.withCredentials = true;

    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status !== 200) {
        container.innerHTML = settings.labels['search.notAvailable'];
      } else if (this.readyState === 4 && this.status === 200) {
        var response;
        try {
          response = JSON.parse(this.responseText);
        } catch (e) {
          container.innerHTML = settings.labels['search.notAvailable'];
          return;
        }
        if (typeof response.response === 'undefined') {
          container.innerHTML = settings.labels['search.notAvailable'];
          return;

        }
        var html = '';

        var htmlTypeFair = '';
        var htmlTypeOther = '';
        if (typeof response.facet_counts !== 'undefined' && typeof response.facet_counts.facet_fields.category !== 'undefined') {

          html += '<div class="search__facet">';

          // reorder and remove not in ordering...
          settings.facets.category.forEach(function callback(item) {
            var facet = item.facet.trim();
            // foreach facets,
            var facetc = response.facet_counts.facet_fields.category.length;
            for (var i = 0; i < facetc; i += 2) {
              if (response.facet_counts.facet_fields.category[i] === facet) {
                if (response.facet_counts.facet_fields.category[i + 1] > 0) {
                  html += '<div class="search__facetItem">' +
                    '<input id="' + response.facet_counts.facet_fields.category[i] + '" class="search__facetItemInput" name="fq" type="checkbox" ' +
                    'value="category:%22' + encodeURIComponent(facet) + '%22" />' +
                    '<label class="search__facetItemLabel" for="' + facet + '">' +
                    '<span class="icon icon-check"></span>' +
                    item.label + ' (' + response.facet_counts.facet_fields.category[i + 1] + ')' +
                    '</label>' +
                    '</div>';
                } else {
                  html += '<div class="search__facetItem hide">' +
                    '<input id="' + response.facet_counts.facet_fields.category[i] + '" class="search__facetItemInput search__facetItemInput--noResults" name="fq" type="checkbox" ' +
                    'value="category:%22' + encodeURIComponent(facet) + '%22" />' +
                    '<label class="search__facetItemLabel" for="' + facet + '">' +
                    '<span class="icon icon-check"></span>' +
                    item.label + ' (' + response.facet_counts.facet_fields.category[i + 1] + ')' +
                    '</label>' +
                    '</div>';
                }
              }
            }
          });

          // add a facet for all responses - first
          var index = html.indexOf('>');
          allCategory = '<div class="search__facetItem">' +
            '<input id="all" class="search__facetItemInput" name="all" type="checkbox" ' +
            'value="" />' +
            '<label class="search__facetItemLabel" for="all">' +
            '<span class="icon icon-check"></span>'+ allInputLabel +
            '</label>' +
            '</div>';
          html = html.slice(0, index + 1) + allCategory + html.slice(index + 1);
          html += '</div>';
          document.querySelector('.js-filter-mobile-plussolr-search').innerHTML = html;
          html = '';
        }

        html += '<p> ' + settings.labels['plus_project.plus_solr.results_count_pre'] + ' '
          + (response.response.numFound ? response.response.numFound : settings.labels['plus_project.plus_solr.results_count_none']) + ' '
          + settings.labels['plus_project.plus_solr.results_count_after'] + '</p>';

        htmlTypeOther += '<ul class="search__results results-list clr">';
        response.response.docs.forEach(function callback(doc) {
          if (doc.type === "Page") {
            var teaser = response.highlighting[doc.id].content.join('[…] ');
            var breadcrumb = '';

            doc.rootline.forEach(function callback(rootline) {
              try {
                var values = JSON.parse(rootline);
                if (values.doktype !== 130 && values.doktype !== 131) {
                  // uid, title, url
                  breadcrumb += '<span>' + values.title + '</span>';
                }
              } catch (e) {
              }
            });

            teaser = teaser.trim();
            if (teaser.length > 200) {
              // on first whitespace at word end we split
              teaser = split(teaser.substring(0, 200));
            }
            if (teaser.length > 1) {
              teaser = '[…] ' + teaser + ' […]';
            } else {
              teaser = '[…]';
            }

            htmlTypeOther += '<li class="results-entry">';
            if (breadcrumb) {
              htmlTypeOther += '<p class="rootline">' + breadcrumb + '</p>';
            }
            htmlTypeOther += '<a href="' + doc.url + '"><h3 class="results-topic contactAside__headline">' + doc.title + '</h3></a>' +
              '<div class="results-teaser"><p class="result-content">' + teaser + '</p></div></li>';
          }
          if (doc.type === "fair") {
            for (var i = 0; i < doc.contentExact.length; i++) {
              try {
                var data = JSON.parse(doc.contentExact[i]);
                var startDate = new Date(data.startDate);
                var endDate = new Date(data.endDate);

                var logoString = '';
                if (data.logo && data.logo.data) {
                  logoString = '<img loading="lazy" alt="' + data.title + '" src="' + data.logo.data + '" class="list__itemImage">';
                }
                var eyecatcherString = '';
                if (data.eyecatcher) {
                  eyecatcherString = '<div class="list__itemEyecatcher">' + data.eyecatcher + '</div>';
                }

                var badgeString = '';
                if (data.badge) {
                  badgeString = '<div class="list__itemBadge"><span>' + data.badge + '</span></div>';
                }

                var labelCity = '';
                var labelCityCountry = '';
                if (typeof data.location.city !== 'undefined' && typeof data.location.country !== 'undefined') {
                  labelCity = '<span class="fairInfo__border">&nbsp;|&nbsp;</span><span class="fairInfo__city">' + data.location.city + '</span>';
                  labelCityCountry = ' | ' + data.location.city + ' | ' + data.location.country;
                }

                htmlTypeFair +=
                  '<li class="list__item"><div class="list__itemTeaserWrapper clr">' +
                  '<div class="list__itemImageWrapper">' +
                  '<a href="' + data.url + '" target="_blank" title="' + settings.labels["plus_project.plus_solr.fair_go_to"] + ' ' + data.title + '">' +
                  eyecatcherString +
                  logoString +
                  '</a>' +
                  '</div>' +
                  '<div class="fairInfo" title="' + getDateString(startDate, endDate) + labelCityCountry + '">' +
                  '<span class="fairInfo__date">' + getDateString(startDate, endDate) + '</span>' + labelCity +
                  '</div>' +
                  '<a href="' + data.url + '" target="_blank" title="' + settings.labels["plus_project.plus_solr.fair_go_to"] + ' ' + data.title + '">' +
                  '<h3 class="list__itemHeadline title" target="_blank" title="' + settings.labels["plus_project.plus_solr.fair_go_to"] + ' ' + data.title + '">' + data.title + '</h3>' +
                  '</a>' +
                  badgeString +
                  '<div class="list__itemText"><p class="faircalendar__listItemSlogan slogan">' + data.subtitle + '</p></div>' +
                  '<a href="' + data.url + '" target="_blank" class="list__itemLink" title="' + settings.labels["plus_project.plus_solr.fair_go_to"] + ' ' + data.title + '">' +
                  settings.labels["teaserbox.link"] + '</a>' +
                  '</div></li>';
              } catch (e) {
              }
            }
          }
          if (doc.type === "MkdbExhibitorIndexBundle|||Documents|||Exhibitor") {
            var boothDatas = [];
            if (typeof doc.av_booths !== "undefined") {
              // check "landesmesse" for many results
              doc.av_booths.forEach(function (booth) {
                if (settings.exhibitor_directory.limitedFairEvents.indexOf(parseInt(booth.fairId)) !== -1) {
                  var boothData = [];
                  if (booth.hallId !== "" && typeof booth.hall.title !== "undefined" && booth.hall.hallId !== "undefined") {
                    boothData.push(booth.hall.title);
                    if (typeof booth.aisleLetter !== "undefined" && booth.aisleLetter !== "") {
                      boothData.push(settings.labels["plus_project.plus_solr.aisle"] + " " + booth.aisleLetter);
                    }
                  }
                  if (typeof booth.boothId !== "undefined" && booth.boothId !== null && typeof booth.hallId !== "undefined" && typeof booth.aisleLetter !== "undefined") {
                    boothData.push(settings.labels["plus_project.plus_solr.booth"] + " " + getHallNumber(booth.hallId) + booth.aisleLetter + booth.boothId);
                  }
                  // append fair title
                  var fairPrefix = "";
                  if (settings.exhibitor_directory.limitedFairEvents.length > 1) {
                    fairPrefix = booth.fairEventTitle + ' ' + booth.fairEventYear + ': ';
                  }
                  if (boothData.length) {
                    boothDatas.push(fairPrefix + boothData.join(', '));
                  }
                }
              });
            }
            boothDatas.sort();

            var contacts = '';
            if (typeof doc.contacts !== "undefined") {
              doc.contacts.forEach(function (contact) {
                if (settings.exhibitor_directory.limitedFairEvents.indexOf(parseInt(contact.fairId)) !== -1) {
                  contacts += '<div class="ed-address clr">\n';
                  contacts += '<p class="ed-address__address">';
                  if (typeof doc.av_street !== "undefined" && doc.av_street) {
                    contacts += doc.av_street + '<br/>';
                  }
                  if (typeof doc.av_zip !== "undefined" && doc.av_zip) {
                    contacts += doc.av_zip;
                    if (typeof doc.av_city !== "undefined" && doc.av_city) {
                      contacts += ' ' + doc.av_city;
                    }
                  } else if (typeof doc.av_city !== "undefined" && doc.av_city) {
                    contacts += doc.av_city;
                  }
                  if (typeof doc.av_country !== "undefined" && doc.av_country) {
                    contacts += ' ' + doc.av_country + '<br/>';
                  } else {
                    contacts += '<br/>';
                  }
                  contacts += '</p>';
                  contacts += '<p class="ed-address__contact">';
                  if (typeof doc.av_telephone !== "undefined" && doc.av_telephone) {
                    contacts += '<a href="tel:' + doc.av_telephone + '" title="' + settings.labels["plus_project.plus_solr.telephone"] + '"><i class="icon icon-phone"></i>' + doc.av_telephone + '<br/>';
                  }
                  if (typeof doc.av_url !== "undefined" && doc.av_url) {
                    var url = '';
                    if (doc.av_url.includes('http')) {
                      url = doc.av_url;
                    }
                    url = 'https://' + doc.av_url;
                    contacts += '<a href="' + url + '" title="' + settings.labels["plus_project.plus_solr.website"] + '" target="_blank">' + doc.av_url + '</a>';
                  }
                  contacts += '</p>';
                }
              });
            }

            htmlTypeOther += '<li class="results-entry document-exhibitor">' +
              '<a href="' + settings.exhibitor_directory.url + '#/' + doc.id.split('|||').pop() + '">' +
              '<h3 class="results-topic contactAside__headline">' + doc.title + '</h3>' +
              '</a><p>' + boothDatas.filter(function (value, index, self) {
                return self.indexOf(value) === index;
              }).join('<br/>') + '</p>' + contacts +
              '</li>';
          }

          if (doc.type === "File|||Pdf") {
            htmlTypeOther += '<li class="results-entry document-file download"><p><a class="icon-file-pdf" href="' + doc.url + '">' + doc.title + '</a></p></li>';
          }
        });
        htmlTypeOther += '</ul>';

        if (htmlTypeFair !== '') {
          html += '<div class="search__results search__results--fairs">' +
            '<ul class="list list--faircalendar clr">' + htmlTypeFair + '</ul>' +
            '</div>';
        }

        html += htmlTypeOther;
        // load all button
        if (hash["rows"] < 100 && response.response.numFound > hash["rows"]) {
          var loadAll = Object.assign({}, hash);
          loadAll["rows"] = 9999;
          html += '<a class="search__more button-inverted" href="' + location.pathname + location.search + '#' + objectToFragment(loadAll) + '">'
            + settings.labels["plus_project.plus_solr.results_load_all"]
            + '</a>';
        } else if (response.response.numFound > response.response.docs.length) {
          html += '<p>' + settings.labels["plus_project.plus_solr.results_more_available"] + '</p>';
        }

        container.innerHTML = html;

        var allInput = document.querySelector('input[name="all"]');
        allInput.onchange = function () {
          if (this.checked) {
            document.querySelectorAll('input[name="fq"]').forEach(function callback(input) {
              input.checked = false;
            });
            hash["fq"] = [];
            window.location.hash = objectToFragment(hash);
          }
        };

        document.querySelectorAll('input[name="fq"]').forEach(function callback(input) {
          var v = input.value;
          var allInput = document.querySelector('input[name="all"]');
          allInput.checked = hash["fq"].length === 0;
          var position = hash["fq"].indexOf(v);
          input.checked = position !== -1;
          if (input.classList.contains('search__facetItemInput--noResults') && position !== -1) {
            hash["fq"] = [];
            window.location.hash = objectToFragment(hash);
          }
          input.onchange = function () {
            if (this.checked && position === -1) {
              hash["fq"].push(v);
            } else if (position !== -1) {
              hash["fq"].splice(position, 1);
            }
            window.location.hash = objectToFragment(hash);
          };

        });

      }
    };
    container.innerHTML = settings.labels["plus_project.plus_solr.actually_loading"];
    var query = settings.uri + "select?q=" + encodeURIComponent(hash["q"]) + "&rows=" + hash["rows"] + "&start=0&highlight[fragsize]=" + 200 / 2 + "&highlight[field]=content&fieldlist=type,contentExact,id,rootline,title,url,av_booths:[json],contacts:[json],av_street,av_telephone,av_url,av_zip,av_city,av_country" + facetQuery + filterQuery + localFilterQuery + '&origin=' + location.origin;
    xhttp.open("GET", query, true);
    xhttp.send();
  }
}

function getDateString(startDate, endDate) {
  if (startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear()) {
    return endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
  }
  if (startDate.getMonth() === endDate.getMonth()) {
    return startDate.getDate() + '. - ' + endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
  }
  return startDate.getDate() + '.' + (startDate.getMonth() + 1) + '. - ' + endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
}

autocomplete();
load();

window.onhashchange = load;
